import React from 'react'
import Image from 'next/image'
export default function BiblicalPrinciples() {
  return (
    <div className="px-4 w-full py-14 relative bg-[#d4e4ea] flex flex-col justify-start items-center gap-2.5">
      {/* Background arrows - hidden on mobile */}
      <div className="absolute left-0 top-0 w-full h-full pointer-events-none hidden md:block">
        <div className="absolute left-0 top-1/2 transform -translate-y-1/2 opacity-30" style={{ width: 335, height: 300, marginTop: 30 }}>
          <Image
            src="/static/images/cka_landing/arrows.png"
            alt="Left background arrow"
            width={335}
            height={300}
            className="w-full h-full object-cover scale-x-[-1]"
          />
        </div>
        <div className="absolute right-0 top-1/2 transform -translate-y-1/2  opacity-30" style={{ width: 335, height: 300, marginTop: 30 }}>
          <Image
            src="/static/images/cka_landing/arrows.png"
            alt="Right background arrow"
            width={335}
            height={300}
            className="w-full h-full object-cover"
          />
        </div>
      </div>
      <div className='w-full h-full  flex flex-col justify-start items-center '>
        <div className='w-full mx-auto max-w-7xl '>
          <div className=" self-stretch flex flex-col justify-start items-center gap-10 relative z-10">
            <div className="self-stretch flex flex-col justify-start items-center gap-12">
              {/* Title and subtitle */}
              <div className="w-full max-w-[1095px] flex flex-col justify-start items-center gap-3">
                <div style={{ fontSize: '24px' }} className="self-stretch text-center justify-start">
                  <span className="text-C-TextPrimary text-2xl md:text-4xl font-medium font-['Lora'] text-[#192f5c]">
                    The Biblical Principles in the CKA<sup style={{ fontSize: '16px' }} className="font-medium font-['Lora'] text-[#192f5c]">®</sup>
                  </span>

                  <span className="text-C-TextPrimary text-2xl md:text-4xl font-medium font-['Lora'] text-[#192f5c]">
                    {' '}Educational Program Have Been
                  </span>
                  <span className="text-C-TextPrimary text-2xl md:text-4xl font-bold font-['Lora'] text-[#192f5c]">
                    {' '}Professionally Proven Over 40 Years
                  </span>
                </div>
                <div className="self-stretch text-center justify-start text-[#192f5c] text-base md:text-xl font-normal font-['Instrument-Sans']">
                  Integration of these principles is critical for this key moment in the Christian financial industry.
                </div>
              </div>

              {/* Statistics cards */}
              <div className=" w-full flex flex-col">
                <div className="flex w-full flex-col md:flex-row gap-4 ">
                  {/* Card 1 */}
                  <div className="w-full  p-6 bg-[#192f5c] rounded-3xl  flex flex-col justify-start items-start gap-4">
                    <div className="justify-start text-[#fbb35c] text-[28px] md:text-5xl font-medium font-['Lora'] leading-[56px]">
                      $22.4 Trillion
                    </div>
                    <div className="self-stretch flex flex-col justify-start items-start gap-10">
                      <div className="self-stretch flex flex-col justify-start items-start gap-4">
                        <div className="self-stretch flex flex-col justify-start items-start gap-6">
                          <div className="w-10 h-0 outline outline-2 outline-offset-[-1px] outline-orange-300" />
                          <div className="self-stretch justify-start">
                            <span className="text-white text-base md:text-lg font-normal font-['Instrument-Sans'] leading-normal">
                              in investable wealth is held by U.S. Christian church members.
                            </span>
                            <sup style={{ fontSize: '14px' }} className="text-white text-base md:text-lg font-normal font-['Instrument-Sans'] leading-normal">*</sup>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Card 2 */}
                  <div className="w-full p-6 bg-[#192f5c] rounded-3xl  flex flex-col justify-start items-start gap-4">
                    <div className="justify-start text-[#fbb35c] text-[28px] md:text-5xl font-medium font-['Lora'] leading-[56px]">
                      50%
                    </div>
                    <div className="self-stretch flex flex-col justify-start items-start gap-10">
                      <div className="self-stretch flex flex-col justify-start items-start gap-4">
                        <div className="self-stretch flex flex-col justify-start items-start gap-6">
                          <div className="w-10 h-0 outline outline-2 outline-offset-[-1px] outline-orange-300" />
                          <div className="self-stretch justify-start">
                            <span className="text-white text-base md:text-lg font-normal font-['Instrument-Sans'] leading-normal">
                              of religiously affiliated HNW investors say it is very important that their financial advisor shares their religious values.
                            </span>
                        
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Card 3 */}
                  <div className="w-full  px-6 py-8 md:py-10 bg-[#192f5c] rounded-3xl  flex flex-col justify-start items-start gap-4">
                    <div className="justify-start text-[#fbb35c] text-[28px] md:text-5xl font-medium font-['Lora'] leading-[56px]">
                      80,000
                    </div>
                    <div className="self-stretch flex flex-col justify-start items-start gap-10">
                      <div className="self-stretch flex flex-col justify-start items-start gap-4">

                        <div className="self-stretch flex flex-col justify-start items-start gap-6">
                          <div className="w-10 h-0 outline outline-2 outline-offset-[-1px] outline-orange-300" />
                          <div className="self-stretch justify-start">
                            <span className="text-white text-base md:text-lg font-normal font-['Instrument-Sans'] leading-normal">
                              individuals came to Kingdom Advisors last year looking for a Certified Kingdom Advisor
                            </span>
                            <sup style={{ fontSize: '12px' }} className="text-white text-base md:text-lg font-normal font-['Instrument-Sans'] leading-normal">®</sup>
                            <span className="text-white text-base md:text-lg font-normal font-['Instrument-Sans'] leading-normal">
                              {' '}aligned with their Christian faith.
                            </span>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Footnotes */}
            <div className="w-full max-w-[1095px] flex flex-col justify-start items-center gap-2">
              <div className="self-stretch text-center justify-start text-blue-950 text-xs font-normal font-['Instrument-Sans'] leading-none">
                * Published Research, Kingdom Advisors, April 29, 2024, 
              <a href="https://s3.us-east-1.amazonaws.com/kawebresources/resourcelibraryfiles/2023-KA-Research-Invested-Market-of-Christians.pdf" target="_blank" rel="noopener noreferrer" className="hover:underline"> ka1.co/research.</a>
                
              </div>
       
            </div>

            {/* CTA Button */}

            <button
              className='w-full md:w-auto bg-transparent border-none p-0'
              onClick={() => document.getElementById('signup')?.scrollIntoView({ behavior: 'smooth' })}
            >
              <div className="w-full md:w-auto md:px-4 flex flex-col  justify-center md:justify-start  items-center  ">
                <div
                  style={{ maxHeight: '56px' }}
                  className="flex-row  justify-center md:justify-start w-full md:w-auto px-8 py-4 bg-[#fbb35c] rounded inline-flex items-center gap-2.5 hover:bg-[#fbb35c]transition-colors cursor-pointer">
                  <div className="w-6 h-6 relative">
                    <Image
                      src="/static/images/cka_landing/blue_arrows.svg"
                      alt="Arrow"
                      width={24}
                      height={24}
                    />
                  </div>
                  <p
                    style={{ fontSize: '16px' }}
                    className="max-w-[220px] md:max-w-none justify-start text-white text-base font-medium font-['Instrument-Sans'] ">
                    <span ><span class="text-blue-950 text-base font-medium font-['Instrument-Sans']">Find Out More About the Impact of a CKA</span><sup class="text-blue-950 text-base font-small font-['Instrument-Sans']" style={{ fontSize: '12px' }}>®</sup><span class="text-blue-950 text-base font-medium font-['Instrument-Sans']"></span></span>
                  </p>
                </div>
              </div>
            </button>

          </div>
        </div>
      </div>
    </div>
  )
}